import React from "react";

function AboutUs() {
  return (
    <section className="pt-12 lg:pb-12">
      <h2 className="text-center uppercase font-bold text-[clamp(2rem,3.5vw,4rem)] mb-[20px] font-[Aquarium]">
        who we are
      </h2>
      <div
        className="flex justify-evenly items-center container mx-auto gap-5"
        data-aos="zoom-in"
        data-aos-duration="1000"
      >
        <div className="max-lg:text-center px-5 lg:w-[50%]">
          <h2 className="text-[#cca000] font-bold uppercase text-[clamp(1.5rem,2vw,2rem)]">
            about our company
          </h2>
          <p className="text-gray-500 text-[clamp(.8rem,2vw,1.2rem)] leading-6 mt-2">
            Welcome to Dr. Hamdy Shehab With our expert engineering
            consultation. <br /> we aim to benefit the whole of society, by
            being the safer, cleaner, and more efficient foundations with our
            project management skills, and our strong interpersonal.
          </p>
          <a
            className="text-center font-semibold hover:bg-black hover:text-white uppercase max-lg:mx-auto block rounded-full border-2 border-black w-40 py-4 mt-6 transition-all"
            href="/about"
          >
            View more
          </a>
        </div>
        <div className="flex justify-between w-[50%] max-lg:hidden">
          <img
            className="w-[48%] relative top-10 shadow-[5px_5px_5px_5px_#b4b4b4]"
            src="/images/aboutus2.webp"
            alt="imagewhoweare"
            loading="lazy"
            data-aos="fade-up"
            data-aos-delay="400"
          />
          <img
            className="w-[48%] shadow-[5px_5px_5px_5px_#b4b4b4]"
            src="/images/aboutus1.webp"
            alt="imagewhoweare"
            loading="lazy"
            data-aos="fade-down"
            data-aos-delay="600"
          />
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
